import React from "react"
import PropTypes from "prop-types"
import ContentLayoutHeader from "../../../components/layouts/ContentLayoutHeader.layout"

const ClientsHeader = ({ setShowClientFormModal }) => {
  return (
    <ContentLayoutHeader
      title="Clientes"
      buttonProps={{
        label: "Crear Cliente",
        icon: "pi pi-plus",
        className: "h-fit",
        onClick: () => {
          setShowClientFormModal(true)
        },
      }}
    />
  )
}

export default ClientsHeader

ClientsHeader.propTypes = {
  showClientFormModal: PropTypes.bool,
  setShowClientFormModal: PropTypes.func,
}

ClientsHeader.defaultProps = {
  showClientFormModal: false,
  setShowClientFormModal: () => {},
}
